import React, { memo } from 'react'
import { InlineDisplayWrapper } from 'apps/fleet-planner/components/load-details/InlineDisplayWrapper'
import * as Types from 'apps/fleet-planner/types'

interface ICarrierInlineDisplayProps extends Types.IInlineDisplayProps<Types.ICarrier['name']> {}

export const CarrierInlineDisplay = memo<ICarrierInlineDisplayProps>(({ value: valueProp }) => {
  const carrierName = valueProp ?? 'Unassigned'
  return <InlineDisplayWrapper label='Carrier' value={carrierName} />
})
